import { Pipe, PipeTransform } from '@angular/core';
import * as Sugar from 'sugar';

@Pipe({
  name: 'fistNameFormat',
})
export class FistNameFormatPipe implements PipeTransform {

  transform(value: string, ...args) {
    let fistName = value.split(' ');
    fistName = fistName.filter( s => s );

    return Sugar.String.camelize(fistName.shift());
  }

}



// WEBPACK FOOTER //
// ./src/pipes/fist-name-format/fist-name-format.ts